import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../../content/css/DangerButton.css';

export default class ConfirmationModal extends Component {

    handleConfirm = () => {
        this.props.onConfirm();
    }

    handleClose = () => {
        this.props.onClose();
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.handleClose}>
                <Modal.Body>
                    <h4>{this.props.warningText}</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleConfirm}>Yes</Button>
                    <Button onClick={this.handleClose}>No</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Misc/ConfirmationModal.js